import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, mailboxDetailFeatureKey } from './mailbox-detail.reducer';

export const mailboxDetailFeature = createFeatureSelector<State>(mailboxDetailFeatureKey);

export const getMailbox = createSelector(mailboxDetailFeature, (state) => {
   return state.mailbox;
});

export const getMailboxCallState = createSelector(mailboxDetailFeature, (state) => {
   return state.callState;
});
